module.exports = __webpack_public_path__ + "static/img/s138.9f525727.png";